import React, { useState } from 'react';
import { iconCategoryCssClass } from '../data/utils/iconCategoryCssClass';
import OverlayWrapper from '../common/OverlayWrapper';
import { getLabel } from '../data/labels';

function DropdownContent(props) {
    return (
        <OverlayWrapper id="xs-categories-overlay">
            <div className="xs_categoriesDropdown z-30 absolute container top-0 left-0 right-0 bottom-0">
                <div className="h-full overflow-y-auto flex flex-col bg-cs1">
                    <div className="z-20 sticky top-0 shrink-0 h-[50px] grid grid-cols-12 items-center border-b border-b-cs7 bg-cs1">
                        <div className="col-start-1 col-end-3 justify-self-center inline-block" onClick={props.toggle}>
                            <i className="bi-x-lg font-medium text-lg text-cs-3"></i>
                        </div>
                        <div className="col-start-3 col-end-11 font-medium text-lg text-cs-3">{getLabel('general.choose_category')}</div>
                        <div className="col-start-11 col-end-13 justify-self-center font-normal text-sm text-cs-3">
                            {/* <span className="bi-arrow-down-up mx-auto font-medium text-lg text-cs-3"></span> */}
                        </div>
                    </div>
                    {props.categories.map(c => {
                        function handleClick(e) {
                            e.stopPropagation();
                            props.toggle(e);
                            props.changeCategory(c.id);
                        }
                        let icon = c.categoryIcon;
                        if (c.id === 0) {
                            icon = iconCategoryCssClass(1, 4);
                        }

                        return (
                            <React.Fragment key={c.id}>
                                {props.selected.id === c.id ?
                                    <div className="relative shrink-0 h-[50px] grid grid-cols-12 items-center bg-cs12 border-y border-y-cs7" onClick={handleClick}>
                                        <div className={"col-start-1 col-end-3 justify-self-center inline-block w-[24px] h-[24px] " + icon}></div>
                                        <div className="col-start-3 col-end-11 font-medium text-sm text-cs-3">{c.descrizione}</div>
                                        <div className="col-start-11 col-end-13">
                                            {c?.eventsCount > 0 &&
                                                <div className="min-h-[24px] min-w-[28px] w-fit px-1 mx-auto flex items-center justify-center bg-cs4 rounded-md">
                                                    <span className="leading-[.6rem] font-medium text-xxs text-cs1">{c.eventsCount}</span>
                                                </div>
                                            }
                                        </div>
                                        <span className="absolute left-0 top-2 bottom-2 w-[4px] bg-cs13 rounded-tr-md rounded-br-md"></span>
                                    </div>
                                    :
                                    <div className="shrink-0 h-[50px] grid grid-cols-12 items-center border-y border-y-cs7" onClick={handleClick}>
                                        <div className={"col-start-1 col-end-3 justify-self-center inline-block w-[24px] h-[24px] " + icon}></div>
                                        <div className="col-start-3 col-end-11 font-medium text-sm text-cs-3">{c.descrizione}</div>
                                        <div className="col-start-11 col-end-13">
                                            {c?.tournamentsCount > 0 &&
                                                <div className="min-h-[24px] min-w-[28px] w-fit px-1 mx-auto flex items-center justify-center bg-cs4 rounded-md">
                                                    <span className="leading-[.6rem] font-medium text-xxs text-cs1">{c.tournamentsCount}</span>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                }
                            </React.Fragment>
                        );
                    })}
                </div>
            </div>
        </OverlayWrapper>
    );
}

export default function CategoriesDropdown(props) {
    const [toggled, setToggled] = useState(false);
    
    function handleClick() {
        setToggled(!toggled)
    }

    const selected = props.selected;
    let icon = selected.categoryIcon;
    if (selected.id === 0) {
        icon = iconCategoryCssClass(1, 4);
    }
    
    return (
        <div className="h-sports-navbar-height grid items-center h-10 bg-cc1">
            <div className="col-start-1 col-end-2 flex items-center justify-center">
                <div className={"inline-block w-[24px] h-[24px] mx-1 " + icon}></div>
            </div>
            <div className="col-start-2 col-end-4 flex items-center justify-start" onClick={handleClick}>
                <span className="text-md text-cs1">{selected.descrizione}</span>
                <i className="bi-caret-down-fill ml-1 text-md text-cs1"></i>
            </div>
            {toggled &&
                <DropdownContent categories={props.categories} selected={selected} toggle={handleClick} changeCategory={props.changeCategory} />
            }
        </div>
    );
}
